import { defineMessages } from 'react-intl'

export const homeLogsMessages = defineMessages({
  pageTitle: {
    id: 'homeLogs.pageTitle',
    description: 'Page title for home Logs page',
    defaultMessage: 'Logs',
  },
  monitoringDisabled: {
    id: 'homeLogs.monitoringDisabled',
    description: 'Telling user that monitoring access is disabled',
    defaultMessage: 'Monitor access is not enabled for this home.',
  },
  notSupportedMac: {
    id: 'homeLogs.notSupportedMac',
    description: 'Telling minimum requirement to fetch Logs on Mac',
    defaultMessage:
      'Remotely fetching logs is not supported on Mac hosts before version 	8.8.2.',
  },
  notSupportedOther: {
    id: 'homeLogs.notSupportedOther',
    description:
      'Telling minimum requirement to fetch Logs on other than Mac host types',
    defaultMessage:
      'Remotely fetching logs is not supported on {hostType} hosts before version 8.9.',
  },
  requestNew: {
    id: 'homeLogs.requestNew',
    description: 'Button text to request new home Logs',
    defaultMessage: 'Get Logs',
  },
  noLogs: {
    id: 'homeLogs.noLogs',
    description: 'Telling that this home does not have any logs (yet)',
    defaultMessage: 'No recent log captures available',
  },
  timedOutTitle: {
    id: 'homeLogs.timedOutTitle',
    description: 'Title that fetching new Logs timed out',
    defaultMessage: 'Request timed out',
  },
  timedOut: {
    id: 'homeLogs.timedOut',
    description: 'Message that fetching new Logs timed out',
    defaultMessage: 'Fetching home logs timed out',
  },
  fetching: {
    id: 'homeLogs.fetching',
    description: 'Text informing that fetching is in progress',
    defaultMessage: 'Fetching...',
  },
  fetchingLeave: {
    id: 'homeLogs.fetchingLeave',
    description:
      'Warning message when user tries to leave the page while fetching is in progress',
    defaultMessage: 'Fetching logs is in progress. Leave the page?',
  },
  notAvailableHost: {
    id: 'notAvailableHost.notAvailableHost',
    description: 'Not available host message',
    defaultMessage: 'Home is offline',
  },
})

export const homeLogsTableMessages = defineMessages({
  uid: {
    id: 'homeLogsTable.uid',
    description: "Column title for Home Logs Table showing host's UID",
    defaultMessage: 'UID',
  },
  processName: {
    id: 'homeLogsTable.processName',
    description: 'Column title for Home Logs Table showing file name',
    defaultMessage: 'File Name',
  },
  softwareVersion: {
    id: 'homeLogsTable.softwareVersion',
    description: 'Title Version for the table of Home Logs page',
    defaultMessage: 'Version',
  },
  uploadTime: {
    id: 'homeLogsTable.uploadTime',
    description: 'Title Uploaded for the table of Home Logs page',
    defaultMessage: 'Uploaded',
  },
})
